import React from 'react';
import Svg from '../Svg';

const IconLetterSpacing01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2C3.55228 2 4 2.44772 4 3L4 21C4 21.5523 3.55229 22 3 22C2.44772 22 2 21.5523 2 21L2 3C2 2.44772 2.44772 2 3 2ZM21 2C21.5523 2 22 2.44772 22 3V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V3C20 2.44772 20.4477 2 21 2ZM11.3372 5.86268C11.7551 5.65685 12.2449 5.65685 12.6628 5.86268C13.03 6.04355 13.2236 6.3606 13.3175 6.52587C13.4181 6.70299 13.5212 6.92987 13.6237 7.15551C13.6287 7.16649 13.6337 7.17747 13.6387 7.18844L17.9104 16.5862C18.1389 17.089 17.9166 17.6818 17.4138 17.9104C16.911 18.1389 16.3182 17.9166 16.0896 17.4138L14.5379 14L9.46209 14L7.91037 17.4138C7.68183 17.9166 7.08898 18.1389 6.5862 17.9104C6.08342 17.6818 5.8611 17.089 6.08963 16.5862L10.3613 7.18844C10.3663 7.17747 10.3713 7.16648 10.3763 7.1555C10.4788 6.92986 10.5819 6.70298 10.6825 6.52587C10.7764 6.3606 10.97 6.04355 11.3372 5.86268ZM10.3712 12L13.6288 12L12 8.41661L10.3712 12Z"
    />
  </Svg>
);

export default IconLetterSpacing01;
